import React, { useEffect, useState } from 'react';
import { api } from '../../api.js';

// A <select> backed by a real, shared, tenant-level option list (not
// session-local) — "+ Add new..." and "⚙ Manage options..." live inside
// the dropdown itself, matching the pattern used elsewhere in the app.
export default function ManagedDropdown({ field, value, onChange, placeholder = 'Select' }) {
  const [options, setOptions] = useState([]);
  const [manageOpen, setManageOpen] = useState(false);

  const load = () => {
    api(`/dispatch/driver-dropdown-options?field=${field}`).then(setOptions).catch(() => setOptions([]));
  };
  useEffect(() => { load(); }, [field]);

  const handleChange = async (e) => {
    const val = e.target.value;
    if (val === '__add__') {
      const name = window.prompt('New value');
      if (name && name.trim()) {
        const created = await api('/dispatch/driver-dropdown-options', { method: 'POST', body: { field, value: name } });
        setOptions(o => [...o, created]);
        onChange(name);
      }
      return;
    }
    if (val === '__manage__') { setManageOpen(true); return; }
    onChange(val);
  };

  const deleteOption = async (id) => {
    await api(`/dispatch/driver-dropdown-options/${id}`, { method: 'DELETE' });
    load();
  };

  return (
    <>
      <select value={value} onChange={handleChange}>
        <option value="">{placeholder}</option>
        {options.map(o => <option key={o.id} value={o.value}>{o.value}</option>)}
        <option disabled>──────────</option>
        <option value="__add__">+ Add new...</option>
        <option value="__manage__">⚙ Manage options...</option>
      </select>
      {manageOpen && (
        <div className="modal-overlay" onClick={() => setManageOpen(false)}>
          <div className="modal" style={{ minWidth: 360 }} onClick={e => e.stopPropagation()}>
            <h3>Manage options</h3>
            <div style={{ maxHeight: 240, overflowY: 'auto', marginBottom: 16 }}>
              {options.length === 0 && <div className="empty">Nothing here yet.</div>}
              {options.map(o => (
                <div key={o.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #eef0f3' }}>
                  <span style={{ fontSize: 13 }}>{o.value}</span>
                  <button type="button" onClick={() => deleteOption(o.id)} style={{ color: 'var(--red)' }}>Delete</button>
                </div>
              ))}
            </div>
            <div className="modal-actions">
              <button type="button" onClick={() => setManageOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
